import * as core from '../../../../../../../core'

import { query } from './change-impacts-table.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.table',
    description:
      'Table view of change impacts filtered by functional area, degree of change, and value of change',
    name: 'Change Impacts Table',
    query,
    variables: [
      {
        id: 'functionalArea',
        name: 'Functional Area',
        type: {
          enumId: 'enum::!change_impact_functional_area',
          isMultiselect: false,
        },
      },
      {
        id: 'degreeOfChange',
        name: 'Degree of Change',
        type: {
          enumId: 'enum::!change_impact_rank',
          isMultiselect: false,
        },
      },
      {
        id: 'valueOfChange',
        name: 'Value of Change',
        type: {
          enumId: 'enum::!change_impact_rank',
          isMultiselect: false,
        },
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
